import axiosInstance from './AxiosInstance';

const API_URL = '/ai-board';

// A question can take several looks at the data, and the AI's per-minute
// limit can make it wait between them -- well past AxiosInstance's 15s.
const ASK_TIMEOUT_MS = 180000;

// What the page's pickers offer: { collections: [{ key: 'lms.batches', db,
// dbLabel, collection }], models: [{ id, label }], defaultModel }.
// Not silent: the app's loading overlay (GlobalLoader) covers the board
// until its models and collections are in, so nothing is picked from an
// empty list.
export const getAiBoardOptions = async () => {
  const response = await axiosInstance.get(`${API_URL}/options`);
  return response.data.data;
};

// The collections a question names, read by the API (no AI involved):
// [{ key: 'lms.batches', word: 'bacthes' }] -- `word` is what in the
// question found it.
export const detectAiBoardCollections = async (message) => {
  const response = await axiosInstance.post(`${API_URL}/detect`, { message }, { silent: true });
  return response.data.data?.collections || [];
};

// history: [{ role: 'user' | 'assistant', content }] -- the conversation so
// far; the API keeps no session, so the page resends it with each question.
// model: a Groq model id; collections: the keys the question may use;
// visualize: answer with charts too.
export const askAiBoard = async (message, history = [], { model, collections, visualize = false } = {}) => {
  const response = await axiosInstance.post(
    `${API_URL}/ask`,
    { message, history, model, collections, visualize },
    // The page shows its own "thinking" bubble; the global overlay stays down.
    { silent: true, timeout: ASK_TIMEOUT_MS }
  );
  // { model, collections, message, queries: [{ key, database, collection, label, pipeline, rows, truncated, error,
  //   chart: { type, labels, datasets: [{ name, values }], note } | null }] }
  return response.data.data;
};
